import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const ErrorFallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 16px;
`;

export const ErrorMessage = styled.p`
  font-size: ${fontSize.font14};
  color: ${theme.greyText3};
`;

export const RetryButton = styled.button`
  padding: 10px 24px;
  border: 1px solid ${theme.blueText};
  border-radius: 8px;
  background: none;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.semiBold};
  color: ${theme.blueText};
  cursor: pointer;
`;
